'use client';

import dynamic from 'next/dynamic';
import { Accordion } from '../../components/accordion';
import { Skeleton } from '../../components/skeleton';
const FilterPlaceholder = () => {
  return <Skeleton className='mb-[2px] h-[42.8px] w-full last:mb-0'></Skeleton>;
};
const FilterPreferences = dynamic(
  () => import('./filters/filter-preferences'),
  { ssr: false, loading: () => <FilterPlaceholder></FilterPlaceholder> }
);
const FilterServices = dynamic(() => import('./filters/filter-services'), {
  ssr: false,
  loading: () => <FilterPlaceholder></FilterPlaceholder>,
});
const FilterAge = dynamic(() => import('./filters/filter-age'), {
  ssr: false,
  loading: () => <FilterPlaceholder></FilterPlaceholder>,
});
const FilterHeight = dynamic(() => import('./filters/filter-height'), {
  ssr: false,
  loading: () => <FilterPlaceholder></FilterPlaceholder>,
});
const FilterLocations = dynamic(() => import('./filters/filter-locations'), {
  ssr: false,
  loading: () => <FilterPlaceholder></FilterPlaceholder>,
});
const FilterToys = dynamic(() => import('./filters/filter-toys'), {
  ssr: false,
  loading: () => <FilterPlaceholder></FilterPlaceholder>,
});
const FilterMobility = dynamic(() => import('./filters/filter-mobility'), {
  ssr: false,
  loading: () => <FilterPlaceholder></FilterPlaceholder>,
});
const FilterBreastScope = dynamic(
  () => import('./filters/filter-breast-scope'),
  { ssr: false, loading: () => <FilterPlaceholder></FilterPlaceholder> }
);
const FilterClothesSize = dynamic(
  () => import('./filters/filter-clothes-size'),
  { ssr: false, loading: () => <FilterPlaceholder></FilterPlaceholder> }
);
const FilterHairColor = dynamic(() => import('./filters/filter-haircolor'), {
  ssr: false,
  loading: () => <FilterPlaceholder></FilterPlaceholder>,
});
const FilterSexuality = dynamic(() => import('./filters/filter-sexuality'), {
  ssr: false,
  loading: () => <FilterPlaceholder></FilterPlaceholder>,
});
const FilterCustomers = dynamic(() => import('./filters/filter-customers'), {
  ssr: false,
  loading: () => <FilterPlaceholder></FilterPlaceholder>,
});
const FilterTattoos = dynamic(() => import('./filters/filter-tattoos'), {
  ssr: false,
  loading: () => <FilterPlaceholder></FilterPlaceholder>,
});
const FilterPiercings = dynamic(() => import('./filters/filter-piercings'), {
  ssr: false,
  loading: () => <FilterPlaceholder></FilterPlaceholder>,
});
const FilterSmoker = dynamic(() => import('./filters/filter-smoker'), {
  ssr: false,
  loading: () => <FilterPlaceholder></FilterPlaceholder>,
});
const FilterOrigin = dynamic(() => import('./filters/filter-origins'), {
  ssr: false,
  loading: () => <FilterPlaceholder></FilterPlaceholder>,
});
const FilterLanguages = dynamic(() => import('./filters/filter-languages'), {
  ssr: false,
  loading: () => <FilterPlaceholder></FilterPlaceholder>,
});

export default function Filter() {
  return (
    <Accordion type='multiple' className='w-full'>
      <FilterPreferences />
      <FilterServices />
      <FilterAge />
      <FilterHeight />
      <FilterLocations />
      <FilterToys />
      <FilterMobility />
      <FilterBreastScope />
      <FilterClothesSize />
      <FilterHairColor />
      <FilterSexuality />
      <FilterCustomers />
      <FilterTattoos />
      <FilterPiercings />
      <FilterSmoker />
      <FilterOrigin />
      <FilterLanguages />
    </Accordion>
  );
}
